function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 9.6h3.2v3.2H8zm4.8 0H16v3.2h-3.2zm4.8 0h3.2v3.2h-3.2zM3.2 19.2h3.2v3.2H3.2zm4.8 0h3.2v3.2H8zm4.8 0H16v3.2h-3.2zM8 14.4h3.2v3.2H8zm4.8 0H16v3.2h-3.2zm4.8 0h3.2v3.2h-3.2zm-14.4 0h3.2v3.2H3.2zM20.8 0v1.6h-3.2V0H6.4v1.6H3.2V0H0v25.6h24V0h-3.2zm1.6 24H1.6V6.4h20.8V24z"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 25,
      height: 25,
      style: {
        marginLeft: 'calc(50% - .5em)',
        position: 'absolute',
        top: 41,
        right: 10,
        zIndex: 100
      }
    }, props), _ref)
  );
};

export default SvgComponent;